import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import { forwardRef } from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
const UIDialogBody = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({
    ref: ref
  }, rest, {
    className: classNames("uiDialogBody private-modal__body has--vertical-spacing", className)
  }));
});
UIDialogBody.displayName = 'UIDialogBody';
export default UIDialogBody;